<div class="popup day-note-popup">
	<div class="popup-header">
		<div class="popup-title"> {{dayNoteId ? 'DAY_NOTES.EDIT' : 'DAY_NOTES.ADD' | translate }}</div>
		<div class="qo-flex-row-center-right">
			<div class="date-selected">{{(selectedDate$ | async) | smLocalDate:'mediumDate'}}</div>
			<div class="department-name">{{(selectedDepartment$ | async).department_name}}</div>
		</div>
	</div>
	<div class="popup-body">
		<form class="inputs" [formGroup]="form" (ngSubmit)="save()" (keyup.enter)="save()">
			<label class="qo-label">
				{{ 'DAY_NOTES.NOTE' | translate }}
				<textarea name="note" formControlName="note" class="qo-input textarea" required></textarea>
			</label>
			<qo-input-checkbox
				formControlName="hidden_note"
				[label]="'DAY_NOTES.HIDDEN_NOTE' | translate"
			></qo-input-checkbox>
		</form>
	</div>

	<div class="popup-footer">
		<button
			*ngIf="dayNoteId"
			class="qo-button-standard qo-no"
			(click)="delete()"
		>
			{{ 'GLOBAL.DELETE' | translate }}
		</button>
		<button class="qo-button-standard qo-grey" (click)="close()">{{ 'GLOBAL.CLOSE' | translate }}</button>
		<button
			class="qo-button-standard qo-primary"
			(click)="save()"
			[disabled]="form.invalid"
		>
			{{(dayNoteId ? 'GLOBAL.SAVE' : 'GLOBAL.ADD') | translate }}
		</button>
	</div>
</div>
